import { render } from "./AppHero.vue?vue&type=template&id=55e7e6ac&ts=true"
import script from "./AppHero.vue?vue&type=script&lang=ts"
export * from "./AppHero.vue?vue&type=script&lang=ts"

import "./AppHero.vue?vue&type=style&index=0&id=55e7e6ac&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__